import React, { useMemo } from 'react';
import { buildWorkoutCoachDiscussion } from './activities/workoutCoachThreadPresentation';
import ExerciseCoachMessageAttachments from './activities/ExerciseCoachMessageAttachments';
import CoachReactionChip from './CoachReactionChip';
import CoachAvatar from './CoachAvatar';

const WorkoutCoachInlineThread = ({
  events = [],
  coachName = 'Coach',
  coachEmoji = '🥋',
  coachImage = null,
  backendService,
}) => {
  const discussion = useMemo(() => buildWorkoutCoachDiscussion(events), [events]);

  if (discussion.length === 0) {
    return (
      <div className="coach-hub-workout-thread-empty">
        No workout chat was recorded for this activity.
      </div>
    );
  }

  return (
    <section className="coach-hub-workout-thread" aria-label="Workout Coach chat">
      <div className="coach-hub-workout-thread-title">Workout chat</div>
      {discussion.map(({ event, presentation }) => {
        const rowSide = ['user', 'user-set'].includes(presentation.kind)
          ? 'user'
          : (presentation.kind === 'coach' ? 'coach' : 'lifecycle');
        const eventKey = event.idempotency_key || event._id || `${event.sequence}-${event.type}`;
        return (
          <div key={eventKey} className={`coach-hub-workout-thread-row ${rowSide}${presentation.reaction ? ' has-reaction' : ''}`}>
            {rowSide === 'coach' && (
              <div className="coach-hub-workout-thread-avatar">
                <CoachAvatar imageUrl={coachImage} emoji={coachEmoji} identitySettled alt={coachName} />
              </div>
            )}
            <div className="coach-hub-workout-thread-bubble">
              {presentation.scopeLabel && (
                <div className="coach-hub-workout-thread-scope">{presentation.scopeLabel}</div>
              )}
              <div>{presentation.text}</div>
              {presentation.reaction && (
                <CoachReactionChip reaction={presentation.reaction} coachName={coachName} />
              )}
              {presentation.attachments?.length > 0 && (
                <ExerciseCoachMessageAttachments
                  attachments={presentation.attachments}
                  backendService={backendService}
                />
              )}
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default WorkoutCoachInlineThread;
